import type { ReactNode } from "react";
import { Label } from "./Label";
import { cn } from "@/lib/utils";

export interface FormFieldShellProps {
  children: ReactNode;
  error?: string;
  htmlFor?: string;
  label?: string;
  labelSuffix?: ReactNode;
  required?: boolean;
  wrapperClassName?: string;
  labelClassName?: string;
  errorClassName?: string;
}

export function FormFieldShell({
  children,
  error,
  htmlFor,
  label,
  labelSuffix,
  required,
  wrapperClassName = "w-full",
  labelClassName,
  errorClassName,
}: Readonly<FormFieldShellProps>) {
  return (
    <div className={wrapperClassName}>
      {label ? (
        <Label
          className={labelClassName}
          htmlFor={htmlFor}
          required={required}
          labelSuffix={labelSuffix}
        >
          {label}
        </Label>
      ) : null}
      {children}
      {error ? (
        <p className={cn("text-xs font-medium text-red-500 dark:text-red-400 mt-1.5 animate-in fade-in-0 duration-150", errorClassName)}>
          {error}
        </p>
      ) : null}
    </div>
  );
}

export default FormFieldShell;
